import { createRentalAccessStore, type RentalAccessSnapshot, type RentalAccessStatus } from './rentalAccessStore'

/**
 * Resposta a "devo ver as páginas do proprietário em Arrendamento?" — ver `useRentalOwnerAccess`.
 * (O mecanismo, partilhado com o lado do inquilino, está em `rentalAccessStore`.)
 */
export type RentalOwnerAccessStatus = RentalAccessStatus
export type RentalOwnerAccessSnapshot = RentalAccessSnapshot

const store = createRentalAccessStore('/api/arrendamentos/proprietario/acesso')

export const getRentalOwnerAccessSnapshot = store.getSnapshot
export const subscribeRentalOwnerAccess = store.subscribe
export const loadRentalOwnerAccess = store.load
export const invalidateRentalOwnerAccess = store.invalidate
